import { Box } from '@mui/material';

import { Tooltip } from '../../../tooltip';
import { useTableContext } from '../../hooks';
import { ColumnGroupModel } from '../../types';

/** Offset border width to avoid double borders when two groups are next to each other */
const borderWidth = 1;

type Props = {
  group: ColumnGroupModel;
  hasSibling: boolean;
};

export const GroupHeader = ({ group, hasSibling }: Props) => {
  const {
    api: {
      current: {
        columnsInfo: { lockedColumnsWidth },
      },
    },
    tableProps: { InfoIcon },
  } = useTableContext()!;

  const leftOffset = group.locked
    ? group.startOffset
    : group.startOffset - lockedColumnsWidth;
  const width = group.endOffset - group.startOffset;

  return (
    <Box
      key={group.id}
      className="DS-Table-GroupHeaderWrapper"
      left={hasSibling ? leftOffset - borderWidth : leftOffset}
    >
      <Box
        className="DS-Table-GroupHeader"
        width={hasSibling ? width + borderWidth : width}
        sx={
          group.sx
            ? // Prevent using && to override theme styling
              { '&.DS-Table-GroupHeader': group.sx as any }
            : undefined
        }
        data-testid={group.testId}
      >
        {group.title}
        {group.infoTooltip && (
          <Tooltip
            arrow
            placement="top"
            {...(group.infoTooltipProps || {})}
            title={group.infoTooltipProps?.title ?? group.infoTooltip}
          >
            {group.InfoIcon ? (
              <group.InfoIcon />
            ) : (
              <InfoIcon className="DS-Table-GroupHeaderIcon" />
            )}
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};
